<template>
  <div class="appHeader">
  <h3 id="headerText">{{headerTitle}}</h3>
    <div class="direction left" @click="prevGo()
       ? $router.go(-1)
    : $router.push('/')">
      <img src="../assets/images/back.png">
    </div>
    <div class="uberButton">
      <span class="imgWrap" @click="goHome()">
            <img src="../assets/images/home.svg" />
        </span>
        <span class="imgWrap" @click="uberClick()">
            <img src="../assets/images/menu.png" />
        </span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import router from '../router'
export default {
  props: {
    transDataSet: {
      headerName: {
        type: String
      },
      prevUrl: {
        type: String
      },
      keyName: {
        type: String
      }
    }
  },
  data () {
    return {
      headerTitle: this.transDataSet.headerName,
      prevBtnUrl: this.transDataSet.prevUrl,
      keyName: this.transDataSet.keyName
    }
  },
  created () {
    if (this.GET_PREV_URL.length >= 1) {
      if (this.GET_PREV_URL === 'explain') {
        this.prevBtnUrl = '/reservation/explain'
      }
      if (this.GET_PREV_URL === 'reCare') {
        this.prevBtnUrl = '/reservation/reCare'
      }
    }
  },
  computed: {
    ...mapGetters([
      'GET_PREV_URL'
    ]),
    ...mapState([
      'prevUrl'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_SIDEBAR_OPEN'
    ]),
    goHome () {
      router.push('/')
    },
    uberClick () {
      this.SET_SIDEBAR_OPEN(true)
    },
    prev () {
      this.$router.push('' + this.prevBtnUrl + '')
      console.log('this.keyname = ', this.keyName)
      if (this.keyName !== undefined) {
        sessionStorage.removeItem('' + this.keyName + '')
      }
      console.log('URL', this.prevBtnUrl)
    },
    prevGo () {
      return window.history?.length > 2
    }
  },
  components: {

  }
}
</script>

<style lang="scss" scoped>
</style>
